import {
  type Provider,
  ConditionOperatorEnum,
  type Condition,
} from '@repo/api-gw-sdk';

import { CLOUD_PROVIDER_PROPERTY } from '../queryBuilder/propertyNames';

export const createCloudProviderCondition = (
  values: Provider[]
): Condition => ({
  property: CLOUD_PROVIDER_PROPERTY,
  operator: ConditionOperatorEnum.In,
  value: values,
});
